import { Grid, Select } from '@mui/material'
import { WaitingTime } from 'api/vehicle/taxisAPI.types'
import Input from 'components/RouteWizard/Input'
import React from 'react'
import { Control, FieldValues } from 'react-hook-form'

interface PickupAndWaitProps {
  control: Control<FieldValues> | any | undefined
  waitingTime: WaitingTime
  isEdit?: boolean
  onChange?: (value: string) => void
}

const PickupAndWait: React.FC<PickupAndWaitProps> = ({
  control,
  waitingTime,
  isEdit,
  onChange,
}) => {
  const [waitingPeriodType, setWaitingPeriodType] = React.useState<string>(
    waitingTime?.freePeriod
      ? 'free'
      : waitingTime?.gracePeriod?.period
      ? 'grace'
      : '',
  )
  console.log('PickupAndWait waitingPeriodType: ', waitingPeriodType)
  console.log('PickupAndWait waitingTime: ', waitingTime)

  React.useEffect(() => {
    onChange?.(waitingPeriodType)
  }, [waitingPeriodType, setWaitingPeriodType])

  return (
    <Grid container spacing={2}>
      <Grid item xs={3}>
        <Select
          disabled={!isEdit}
          onChange={(event) => {
            const selectedValue = event.target.value as string
            setWaitingPeriodType(selectedValue)
          }}
          fullWidth
          value={waitingPeriodType}
          native
          inputProps={{
            name: 'waitingTimeType',
          }}
        >
          <option value="">Waiting Type (Not Required)</option>
          <option value="free">Free Period</option>
          <option value="grace">Grace Period</option>
        </Select>

        {/* //   name="waitingTimeType"
        //   options={WaitingPeriod}
        //   label={'Waiting Time Type'}
        //   topRow={{ value: '', label: 'Select Waiting Type' }}
        //   sx={{ width: '100%' }}
        //   {...{ readOnly: isEdit }}
        //   onChange={(value: string) => setWaitingPeriodType(value)}
        /> */}
      </Grid>
      {waitingPeriodType === 'free' && (
        <Grid item xs={4}>
          <Input
            name="waitingTime.freePeriod"
            control={control}
            label="Free Waiting Time"
            fullWidth
            type="number"
            InputProps={{
              endAdornment: <span>minutes</span>,
            }}
            disabled={!isEdit}
          />
        </Grid>
      )}
      {waitingPeriodType === 'grace' && (
        <Grid item xs={4}>
          <Input
            name="waitingTime.gracePeriod.period"
            control={control}
            label="Grace Period Waiting Time"
            fullWidth
            type="number"
            InputProps={{
              endAdornment: <span>minutes</span>,
            }}
            disabled={!isEdit}
          />
        </Grid>
      )}
      {waitingPeriodType !== '' && (
        <Grid item xs={3}>
          <Input
            name="waitingTime.chargingPeriod.period"
            control={control}
            label="Additional Waiting Units"
            fullWidth
            type="number"
            InputProps={{
              endAdornment: <span>minutes</span>,
            }}
            disabled={!isEdit}
          />
        </Grid>
      )}
    </Grid>
  )
}

export default PickupAndWait
